/**
 * i18n Configuration
 * Production-ready setup with namespace support, lazy loading, and language detection
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationIT from '../locales/it/translation.json';
import translationEN from '../locales/en/translation.json';

// Translation resources organized by namespace
const resources = {
  it: {
    translation: translationIT,
  },
  en: {
    translation: translationEN,
  },
};

// Language detector configuration
const languageDetectorOptions = {
  // Order of language detection - localStorage takes priority
  order: ['localStorage', 'htmlTag'],

  // Keys to lookup language from
  lookupLocalStorage: 'tradingspace_language',

  // Cache user language on
  caches: ['localStorage'],
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,

    // Default language — English-first product. Italian stays available via the
    // switcher, but anything untranslated (or any visitor we can't detect)
    // falls back to English, never Italian.
    fallbackLng: 'en',

    // Allowed languages
    supportedLngs: ['en', 'it'],

    // Namespace configuration
    defaultNS: 'translation',

    // Debug mode (disable in production)
    debug: false,

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already does escaping
      formatSeparator: ',',
    },

    // Language detector options
    detection: languageDetectorOptions,

    // React options
    react: {
      useSuspense: false, // Set to false to avoid suspense issues
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'span'],
    },

    // Return empty string for missing keys instead of key itself
    returnEmptyString: false,

    // Key separator
    keySeparator: '.',

    // Namespace separator
    nsSeparator: ':',
  })
  .then(() => {
    const currentLang = i18n.language;
    console.log(`🌍 i18n initialized with language: ${currentLang}`);
  });

// Export configured i18n instance
export default i18n;
